import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { getViewInitialState } from 'src/store/view/reducer';
import { isSSR } from 'src/helpers/ssr';
import reducer from './rootReducer';
import sagas from '../sagas';

const composeEnhancers =
  (!isSSR && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

const getStore = ({ logo }) => {
  const preloadedState = { logo, view: getViewInitialState() };

  const store = createStore(
    reducer,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    preloadedState as any,
    composeEnhancers(applyMiddleware(...middlewares)),
  );
  sagaMiddleware.run(sagas);
  return store;
};

export default getStore;
